import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=c8230970&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qhotian/Project/haodf/hb-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8230970')) {
      api.createRecord('c8230970', component.options)
    } else {
      api.reload('c8230970', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=c8230970&", function () {
      api.rerender('c8230970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComp/video/Video.vue"
export default component.exports